import React from "react";
import { transformToHtml } from "../../../utils/CommonUtils";

export default function FlightNumberField({
  value = "",
  fieldConfig,
  onChange,
}) {
  const handleChange = (e) => {
    if (e?.target?.value !== undefined && onChange) {
      onChange(e);
    }
  };

  return (
    <div className="fs-header__field">
      {fieldConfig?.label && (
        <div className="fs-header__field-label fontSize12">
          {transformToHtml(fieldConfig.label)}
        </div>
      )}
      <input
        className="fs-header__field-input fs-header__field-input--captext fontSize14"
        value={value}
        placeholder={fieldConfig?.placeHolder || "Flight Number"}
        onChange={handleChange}
        aria-label={fieldConfig?.label || "Flight Number"}
        maxLength={10}
        type="text"
        pattern="[A-Za-z0-9]*"
        title="Please enter a valid flight number"
      />
    </div>
  );
}
